import { ErrorMsg } from '@monorepo/api/src/Rest/types'
import { trackEvent, type LandingType, type GameCategory, type LabelClick } from './trackEvent'

// ============================================
// Аутентификация / регистрация
// ============================================

/** Клик на кнопку логина/регистрации (шапка, поп-ап и т.д.) */
export const trackLoginClick = (landingType: LandingType, label: LabelClick = 'header') => {
  const eventData = {
    event: 'login_click',
    category: 'authentication',
    action: 'click',
    label,
    landing_type: landingType,
  }
  console.log('📊 [trackLoginClick]', eventData)
  trackEvent(eventData)
}

/** Переключение между способом регистрации (телефон / email) */
export const trackSignUpMethodSwitch = (method: 'phone' | 'email', landingType: LandingType) => {
  const eventData = {
    event: 'sign_up_method',
    category: 'authentication',
    action: 'switch',
    label: method,
    landing_type: landingType,
  }
  console.log('📊 [trackSignUpMethodSwitch]', eventData)
  trackEvent(eventData)
}

/** Пользователь ввёл достаточно символов в поле формы (email/password/phone) */
export const trackInputFilled = (fieldName: LabelClick, landingType: LandingType) => {
  const eventData = {
    event: fieldName,
    category: 'authentication',
    action: 'click',
    landing_type: landingType,
  }
  console.log('📊 [trackInputFilled]', eventData)
  trackEvent(eventData)
}

/** Результат регистрации: успех или ошибка */
export const trackRegistration = (
  status: 'success' | 'error',
  registrationType: 'phone' | 'email' | undefined,
  landingType: LandingType,
  error?: ErrorMsg,
) => {
  const parseError = error
    ? Array.isArray(error.detail)
      ? error.detail.map((e) => e.msg).join(', ')
      : typeof error.detail === 'string'
        ? error.detail
        : JSON.stringify(error.detail)
    : ''
    
  const eventData = {
    event: 'sign_up',
    category: 'authentication',
    action: 'click',
    status: status,
    landing_type: landingType,
    label: registrationType,
    error_message: parseError,
  }

  if (registrationType !== undefined) {
    eventData.label = registrationType
  }

  console.log('📊 [trackRegistration]', eventData)
  trackEvent(eventData)
}

// ============================================
// Навигация
// ============================================

/** Смена языка на лендинге */
export const trackLanguageSelect = (landingType: LandingType, selectedLanguage: string) => {
  const eventData = {
    event: 'language_select',
    action: 'click',
    label: selectedLanguage,
    landing_type: landingType,
  }
  console.log('📊 [trackLanguageSelect]', eventData)
  trackEvent(eventData)
}

// ============================================
// Игра (колесо / карты)
// ============================================

/** Взаимодействие с игрой: спин колеса, переворот карты и т.д. */
export const trackGameInteraction = (params: {
  landingType: LandingType
  gameCategory: GameCategory
  gameId?: string
  attempt: number
}) => {
  const eventData = {
    event: 'play_game',
    category: 'mini_game',
    action: 'click',
    landing_type: params.landingType,
    game_category: params.gameCategory,
    game_id: params.gameId,
    attempt: params.attempt,
  }
  console.log('📊 [trackGameInteraction]', eventData)
  trackEvent(eventData)
}
/** Кнопка перехода на форму регистрации на странице с лицензией */

export const trackCTAButton = (params: {
  landingType: LandingType
  gameCategory: GameCategory
  gameId?: string
}) => {
  const eventData = {
    event: 'cta_button',
    category: 'mini_game',
    action: 'click',
    landing_type: params.landingType,
    game_category: params.gameCategory,
    game_id: params.gameId,
  }
  console.log('📊 [trackCTAButton]', eventData)
  trackEvent(eventData)
}
